import i18n from '@/localisation/i18n';
import clsx from 'clsx';

export const EditButton = ({
  isEditing,
  onClick,
  isDisabled,
}: {
  isEditing: boolean;
  isDisabled: boolean;
  onClick: () => void;
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={clsx(
        'btn btn-xs bg-transparent border-additional mt-1',
        isEditing && 'border-orange text-orange',
        isDisabled && '!border-orange !text-orange opacity-50'
      )}
    >
      {isEditing ? i18n.t('save') : i18n.t('edit')}
    </button>
  );
};
